export default __webpack_public_path__ + "static/Montserrat-ExtraLightItalic-338d80b0603bc186b146a5c44e7cdc4d.ttf";